import { render } from "./MyTestResults.vue?vue&type=template&id=5ede2c01&scoped=true"
import script from "./MyTestResults.vue?vue&type=script&lang=js"
export * from "./MyTestResults.vue?vue&type=script&lang=js"

import "./MyTestResults.vue?vue&type=style&index=0&id=5ede2c01&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ede2c01"]])

export default __exports__